const others = [
  {
    name: 'error-404-280',
    type: 'other',
    size: '280px',
    height: 280,
    width: 280
  },
  {
    name: 'error-404-320',
    type: 'other',
    size: '320px',
    height: 320,
    width: 320
  },
  {
    name: 'office-in-a-box',
    type: 'other',
    size: '200 x 355px',
    height: 355,
    width: 200
  }
];

export default others;


// WEBPACK FOOTER //
// ./src/containers/foundations/Illustrations/constants/others.js